export class NetworkClassificationCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "networkClassifications",
            "baseName": "networkClassifications",
            "type": "Array<NetworkClassification>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NetworkClassificationCondition.attributeTypeMap;
    }
    constructor() {
    }
}
